export default {
  data() {
    return {
      roomCardRefs: [], // 儲存房間卡片 DOM 元素的引用
      rooms: [
        {
          title: "靜湯閣",
          description: "靜謐湯屋，遠離塵囂，沉浸溫泉溫暖，享受靜謐放鬆時光。",
          route: "SpaJingTangGe",
          image: "spa1.jpg", // 對應檔案名
          isVisible: false, // 初始為隱藏
        },
        {
          title: "泉韻居",
          description:
            "融合自然泉水清新與舒適，帶來身心平衡，是恢復活力的理想之地。",
          route: "SpaQuanYunJu",
          image: "spa2.jpg", // 對應檔案名
          isVisible: false, // 初始為隱藏
        },
        {
          title: "湯之苑",
          description: "融合自然的溫泉聖地，寧靜庭院與恬淡水景，悠然享受每刻。",
          route: "SpaTangZhiYuan",
          image: "spa3.jpg", // 對應檔案名
          isVisible: false, // 初始為隱藏
        },
      ],

      pricingData: [
        {
          type: "靜湯閣",
          size: "10",
          beds: "2",
          price: "NT$ 2,500",
        },
        {
          type: "泉韻居",
          size: "15",
          beds: "4",
          price: "NT$ 4,500",
        },
        {
          type: "湯之苑",
          size: "15",
          beds: "6",
          price: "NT$ 7,500",
        },
      ],
      bookingNotices: [
        "現場備有洗沐用品、浴巾及其他多項基本備品。",
        "基於安全考量，湯屋內嚴禁戲水及奔跑。",
        "湯屋採完全預約制，可電話預約或使用線上預約系統預訂。",
        "每日最後預定時間為20:00。",
        "使用當天請提前5-10分鐘抵達辦理入場，預訂保留時間為10分鐘，如遲到且未提前告知則視為取消，該時段即空出販售，敬請配合。",
        "圖片僅供參考，實際以現場為主。",
      ],
    };
  },

  mounted() {
    this.setupScrollObserver(); // 在 mounted 中啟動觀察者
  },

  methods: {
    goToRoomDetail(routeName) {
      // 使用 Vue Router 跳轉到指定的路由名稱
      this.$router.push({ name: routeName });
    },

    setRoomCardRef(el, index) {
      if (el) {
        this.roomCardRefs[index] = el;
      }
    },

    setupScrollObserver() {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const index = parseInt(entry.target.dataset.index);
            if (this.rooms[index]) {
              // 當卡片進入視窗時，顯示卡片
              this.rooms[index].isVisible = entry.isIntersecting;
            }
          });
        },
        { threshold: 0.3 }
      );

      this.$nextTick(() => {
        if (this.roomCardRefs) {
          this.roomCardRefs.forEach((element, index) => {
            if (element) {
              element.dataset.index = index;
              observer.observe(element); // 監聽每個卡片
            }
          });
        }
      });
    },
  },
};
